/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSet = /* GraphQL */ `
  mutation CreateSet(
    $input: CreateSetInput!
    $condition: ModelSetConditionInput
  ) {
    createSet(input: $input, condition: $condition) {
      id
      title
      type
      setType
      description
      durations
      sequences
      owner
      exercises {
        items {
          id
          setID
          exerciseID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSet = /* GraphQL */ `
  mutation UpdateSet(
    $input: UpdateSetInput!
    $condition: ModelSetConditionInput
  ) {
    updateSet(input: $input, condition: $condition) {
      id
      title
      type
      setType
      description
      durations
      sequences
      owner
      exercises {
        items {
          id
          setID
          exerciseID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSet = /* GraphQL */ `
  mutation DeleteSet(
    $input: DeleteSetInput!
    $condition: ModelSetConditionInput
  ) {
    deleteSet(input: $input, condition: $condition) {
      id
      title
      type
      setType
      description
      durations
      sequences
      owner
      exercises {
        items {
          id
          setID
          exerciseID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createActivity = /* GraphQL */ `
  mutation CreateActivity(
    $input: CreateActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    createActivity(input: $input, condition: $condition) {
      id
      userID
      set
      date
      duration
      status
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateActivity = /* GraphQL */ `
  mutation UpdateActivity(
    $input: UpdateActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    updateActivity(input: $input, condition: $condition) {
      id
      userID
      set
      date
      duration
      status
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteActivity = /* GraphQL */ `
  mutation DeleteActivity(
    $input: DeleteActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    deleteActivity(input: $input, condition: $condition) {
      id
      userID
      set
      date
      duration
      status
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createUserScheduledSet = /* GraphQL */ `
  mutation CreateUserScheduledSet(
    $input: CreateUserScheduledSetInput!
    $condition: ModelUserScheduledSetConditionInput
  ) {
    createUserScheduledSet(input: $input, condition: $condition) {
      id
      userID
      day
      hour
      set
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateUserScheduledSet = /* GraphQL */ `
  mutation UpdateUserScheduledSet(
    $input: UpdateUserScheduledSetInput!
    $condition: ModelUserScheduledSetConditionInput
  ) {
    updateUserScheduledSet(input: $input, condition: $condition) {
      id
      userID
      day
      hour
      set
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteUserScheduledSet = /* GraphQL */ `
  mutation DeleteUserScheduledSet(
    $input: DeleteUserScheduledSetInput!
    $condition: ModelUserScheduledSetConditionInput
  ) {
    deleteUserScheduledSet(input: $input, condition: $condition) {
      id
      userID
      day
      hour
      set
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createDefaultScheduledSet = /* GraphQL */ `
  mutation CreateDefaultScheduledSet(
    $input: CreateDefaultScheduledSetInput!
    $condition: ModelDefaultScheduledSetConditionInput
  ) {
    createDefaultScheduledSet(input: $input, condition: $condition) {
      id
      day
      hour
      set
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDefaultScheduledSet = /* GraphQL */ `
  mutation UpdateDefaultScheduledSet(
    $input: UpdateDefaultScheduledSetInput!
    $condition: ModelDefaultScheduledSetConditionInput
  ) {
    updateDefaultScheduledSet(input: $input, condition: $condition) {
      id
      day
      hour
      set
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDefaultScheduledSet = /* GraphQL */ `
  mutation DeleteDefaultScheduledSet(
    $input: DeleteDefaultScheduledSetInput!
    $condition: ModelDefaultScheduledSetConditionInput
  ) {
    deleteDefaultScheduledSet(input: $input, condition: $condition) {
      id
      day
      hour
      set
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createExercise = /* GraphQL */ `
  mutation CreateExercise(
    $input: CreateExerciseInput!
    $condition: ModelExerciseConditionInput
  ) {
    createExercise(input: $input, condition: $condition) {
      id
      title
      favourite
      headline
      subtitle
      search
      target
      image
      icon
      mediaType
      videoID
      duration
      displayOrder
      displayDuration
      type
      color
      how
      equipment
      sets {
        items {
          id
          setID
          exerciseID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateExercise = /* GraphQL */ `
  mutation UpdateExercise(
    $input: UpdateExerciseInput!
    $condition: ModelExerciseConditionInput
  ) {
    updateExercise(input: $input, condition: $condition) {
      id
      title
      favourite
      headline
      subtitle
      search
      target
      image
      icon
      mediaType
      videoID
      duration
      displayOrder
      displayDuration
      type
      color
      how
      equipment
      sets {
        items {
          id
          setID
          exerciseID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteExercise = /* GraphQL */ `
  mutation DeleteExercise(
    $input: DeleteExerciseInput!
    $condition: ModelExerciseConditionInput
  ) {
    deleteExercise(input: $input, condition: $condition) {
      id
      title
      favourite
      headline
      subtitle
      search
      target
      image
      icon
      mediaType
      videoID
      duration
      displayOrder
      displayDuration
      type
      color
      how
      equipment
      sets {
        items {
          id
          setID
          exerciseID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createActivityHistory = /* GraphQL */ `
  mutation CreateActivityHistory(
    $input: CreateActivityHistoryInput!
    $condition: ModelActivityHistoryConditionInput
  ) {
    createActivityHistory(input: $input, condition: $condition) {
      id
      userID
      duration
      date
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateActivityHistory = /* GraphQL */ `
  mutation UpdateActivityHistory(
    $input: UpdateActivityHistoryInput!
    $condition: ModelActivityHistoryConditionInput
  ) {
    updateActivityHistory(input: $input, condition: $condition) {
      id
      userID
      duration
      date
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteActivityHistory = /* GraphQL */ `
  mutation DeleteActivityHistory(
    $input: DeleteActivityHistoryInput!
    $condition: ModelActivityHistoryConditionInput
  ) {
    deleteActivityHistory(input: $input, condition: $condition) {
      id
      userID
      duration
      date
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createSetExercises = /* GraphQL */ `
  mutation CreateSetExercises(
    $input: CreateSetExercisesInput!
    $condition: ModelSetExercisesConditionInput
  ) {
    createSetExercises(input: $input, condition: $condition) {
      id
      setID
      exerciseID
      set {
        id
        title
        type
        setType
        description
        durations
        sequences
        owner
        exercises {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      exercise {
        id
        title
        favourite
        headline
        subtitle
        search
        target
        image
        icon
        mediaType
        videoID
        duration
        displayOrder
        displayDuration
        type
        color
        how
        equipment
        sets {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSetExercises = /* GraphQL */ `
  mutation UpdateSetExercises(
    $input: UpdateSetExercisesInput!
    $condition: ModelSetExercisesConditionInput
  ) {
    updateSetExercises(input: $input, condition: $condition) {
      id
      setID
      exerciseID
      set {
        id
        title
        type
        setType
        description
        durations
        sequences
        owner
        exercises {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      exercise {
        id
        title
        favourite
        headline
        subtitle
        search
        target
        image
        icon
        mediaType
        videoID
        duration
        displayOrder
        displayDuration
        type
        color
        how
        equipment
        sets {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSetExercises = /* GraphQL */ `
  mutation DeleteSetExercises(
    $input: DeleteSetExercisesInput!
    $condition: ModelSetExercisesConditionInput
  ) {
    deleteSetExercises(input: $input, condition: $condition) {
      id
      setID
      exerciseID
      set {
        id
        title
        type
        setType
        description
        durations
        sequences
        owner
        exercises {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      exercise {
        id
        title
        favourite
        headline
        subtitle
        search
        target
        image
        icon
        mediaType
        videoID
        duration
        displayOrder
        displayDuration
        type
        color
        how
        equipment
        sets {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
